<div class="program">
  <div class="header-custom">
    <div class="header-title" [style.color]="closed ? 'rgba(255,255,255, 0.5)' : 'white'">
      <div class="triangle" [style.borderTopColor]="!closed ? color : 'rgba(0,0,0, 0.2)'"></div>
      <div>{{title}}</div>
      @if (isOnEvent === 'reward' && rewardsDeleted) {
        <div class="rewards-deleted">{{'event.rewards_deleted' | translate}}</div>
      }
    </div>
    <div class="header-date">
      @if (!type) {
        <span>{{date | date}}</span>
      }
      @if (type) {
        <div class="future-date">{{date}}</div>
      }
      <!--<warteliste *ngIf="isOnEvent === 'false'" [color]="'white'" [id]="id"></warteliste>-->
      <!--<gebucht *ngIf="isOnEvent === 'true'" [color]="'white'" [id]="id"></gebucht>-->
      @if (isOnEvent === 'reward') {
        <i class="material-icons">
          check
        </i>
      }
      @if (isOnEvent === 'correction+') {
        <i class="material-icons">
          add
        </i>
      }
      @if (isOnEvent === 'correction-') {
        <i class="material-icons">
          remove
        </i>
      }
      @if (isOnEvent === 'correction+' || isOnEvent === 'correction-'
        || (isOnEvent === 'reward' && !rewardsDeleted) ) {
        <i class="material-icons" (click)="deleteReward(id)">delete</i>
      }
    </div>
  </div>
  <div class="info">
    @if (type === 'future') {
      <div class="info-title future">
        <div style="width: 90%">{{info?.title}}</div>
        <div class="forward"><mat-icon (click)="goToEvent(info)">forward</mat-icon></div>
      </div>
    }
    @if (!type || type !== 'future') {
      <div class="info-title">{{info?.title}}</div>
    }
    <div class="info-title">{{codeInfo}}</div>
    @if (subEvents?.length) {
      <div class="sub-events">
        <div class="sub-title">
          {{'event.sub_events' | translate}}
          @if (!info?.finishBooking) {
            <span class="not-booked">({{'event.not_booked_yet' | translate}})</span>
            }:
          </div>
          @for (event of subEvents; track event) {
            <div class="sub-event">
              - {{event?.title}}
            </div>
          }
        </div>
      }
      @if (completed) {
        <div class="targetGroup">
          @if (!editTarget) {
            <div class="name">{{allInfo?.targetGroup?.ageMask}}</div>
          }
          @if (editTarget) {
            <mat-form-field>
              <mat-select [(ngModel)]="selectedTG">
                @for (tg of TGForRewards; track tg) {
                  <mat-option [value]="tg.id">
                    <span>{{tg?.ageMask}}</span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (!editTarget) {
            <mat-icon class="edit" (click)="editTG()">edit</mat-icon>
          }
          @if (editTarget) {
            <mat-icon class="edit save" (click)="saveTG()">save</mat-icon>
          }
          @if (editTarget) {
            <mat-icon class="edit cancel" (click)="cancelEditTG()">close</mat-icon>
          }
        </div>
      }
    </div>
  </div>

